import React from 'react'
import { Link, c } from './common'

function DesktopNavigation({ links }) {
    return <ul {...c('menu')}>{links.map(MenuItem)}</ul>
}

const LinkListing = DesktopNavigation

function MenuItem({ name, links, url }) {
    if (!name) {
        return null
    }
    return (
        <li key={`${name}-${url}`} {...c('item')}>
            {links?.length > 0 ? (
                <>
                    <Link href={url}>{name}</Link>
                    <LinkListing links={links} />
                </>
            ) : (
                <Link href={url}>{name}</Link>
            )}
        </li>
    )
}

export default DesktopNavigation
